const type = 'SET_SPLIT_INVOICE_AMOUNT_SLIDER';

const setSplitInvoiceAmountSlider = (data) => ({
  data,
  type,
});

export { type };
export default setSplitInvoiceAmountSlider;
